<template>
  <div id="wrapper">
    <v-overlay :value="overlay">
  <v-progress-circular indeterminate size="64" color="accent"></v-progress-circular>
        </v-overlay>
    <v-container fluid>
      <v-row dense>
        <v-col
          v-for="item in $store.state.user_menu"
          :key="item.title"
          :to="item.link"
          :cols="3"
        >
          <v-card :to="item.link"
            width="400px">
            <v-img
              :src="require('../../static/img/'+item.imagen)"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="100px"
              
            >
              <v-card-title></v-card-title>
            </v-img>

            <v-card-actions>
              <v-spacer>{{item.title}}</v-spacer>

              <v-btn icon>
                <v-icon>{{item.icon}}</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'

var logged = false
var items = []

export default {
  name: 'App',
  data () {
    return {
      items,
      drawer: false,
      type_message: 'info',
      alert_message: 'Ingrese usuario y contraseña',
      right: null,
      color: 'primary',
      color_alert: 'primary',
      colors: ['primary', 'accent', 'warning lighten-2', 'teal', 'orange'],
      logged,
      dialog: false,
      alert: false,
      user: '',
      password: '',
      mail: '',
      displayName: '',
      //user_data: { ApiUser_id: '-', ApiUser_GivenName: '', ApiUser_EMail: '-' },
      user_data: { ApiUser_id: this.$store.state.ApiUser_id, ApiUser_GivenName: this.$store.state.ApiUser_GivenName, ApiUser_EMail: this.$store.state.ApiUser_EMail,  ApiUser_Supplier:  this.$store.state.ApiUser_Supplier, Supplier_Description: this.$store.state.MotherSupplier_Desc },
      process: false,
      api_tool_url: process.env.VUE_APP_API_TOOL_URL,
      toolbar: this.$store.state.toolbar,
      token: this.$route.params.token,
      overlay: false
    }
  },
  created () {
    Vue.set(this.toolbar, 'title', 'Home')
    if(this.token != undefined) {
      this.items = []
      this.overlay = false
      //this.check_token()
      //this.overlay = false
    }
},
methods: {
    // check_token: function() {
    //   var data
    //   data = {
    //     ApiKey_id: this.token
    //   }
    //   axios.post(this.api_tool_url + '/check_token', data)
    //     .then(response => {
    //       sessionStorage.setItem('ApiUser_id', response.data.ApiUser_id)
    //       sessionStorage.setItem('access_token', response.data.ApiKey_id)
    //       this.logged = true
    //       this.$store.commit('updateUser_detail',response.data)
    //       this.user_data.ApiUser_id = response.data.ApiUser_id
    //       //this.user_data.ApiUser_EMail = this.mail
    //       //this.user_data.ApiUser_GivenName = this.displayName
    //       //this.get_menu()
    //       this.overlay = false
    //     })
    //     .catch(error => {
    //       console.log(error)
    //       this.alert = true
    //       this.overlay = false
    //       this.$router.push('/')
    //     })

    // }
    // get_menu: function() {
    //   let data = {
    //     ApiUser_id: this.user_data.ApiUser_id
    //   }

    //   let config = {
    //     headers: {
    //       "api-user": this.user_data.ApiUser_id
    //     }
    //   }

    //   axios.post(this.api_tool_url + '/get_usermenu', data, config)
    //     .then(response => {
    //       this.items.push({ title: 'Home', icon: 'mdi-home', link: "/" + this.token + '/home', imagen: 'mdi-home.jpg' })
    //       response.data.ResultRows.forEach(menu => {
    //           this.items.push({ title: menu.ApiMenu_Title, icon: menu.ApiMenu_Icon, link: "/" + this.token + menu.ApiMenu_Link, imagen: menu.ApiMenu_Image })
    //       })
    //       this.overlay = false
    //       this.$router.push("/" + this.token + '/home')
    //     })
    //     .catch(error => {
    //       console.log(error)
    //       this.overlay = false
    //       this.alert = true
    //     })
    // }
  }
}
</script>

<style scoped>
  #wrapper {
        position:relative;
  }

  #middle {
        position:absolute;
  }

  #middle {
        top:50px;
        bottom:50px;
        width:100%;
        background:black;
  }

  .div {
    background-image: url('../assets/data-inf.jpeg');
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue